// extracted by mini-css-extract-plugin
export var cardContainer = "_ot-0";
export var cardHeader = "_ot-2";
export var collapsedState = "_ot-3";
export var dragHandle = "_ot-5";
export var dragHandleIcon = "_ot-6";
export var dragging = "_ot-1";
export var titleArea = "_ot-4";